import React from 'react';
import PropTypes from 'prop-types';

const VideoItem = ({ src }) => (
  <div className="video-carousel-container">
    <video
      className="video-carousel"
      autoPlay
      controls
      disablePictureInPicture
      controlsList="nodownload"
      muted
      loop={false}
      src={`${src}`}
    />
  </div>
);

VideoItem.propTypes = {
  src: PropTypes.string.isRequired,
};

export default VideoItem;
